import React, { useEffect, useState } from "react";
import {
  Alert,
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Stack,
  TextField,
} from "@mui/material";
import { patchPagosRechazo } from "./ApiServices";
import ExpedienteArchivos from "./ExpedienteArchivos";
import {
  TIPOS_ARCHIVO_RECHAZO,
  esReposicionExenta,
} from "./chequesRechazos.constants";

export default function ModalPagosRechazo({ open, onClose, rechazo, onOk }) {
  const [obs, setObs] = useState("");
  const [avisoJefe, setAvisoJefe] = useState(true);
  const [gestionaReposicion, setGestionaReposicion] = useState(true);
  const [guardando, setGuardando] = useState(false);
  const [error, setError] = useState("");

  const exenta = esReposicionExenta(rechazo);

  useEffect(() => {
    if (!open) return;
    setObs("");
    setAvisoJefe(true);
    setGestionaReposicion(!esReposicionExenta(rechazo));
    setError("");
  }, [open, rechazo]);

  const idRechazo = rechazo?.id ?? rechazo?.id_rechazo;

  const guardar = async () => {
    if (!idRechazo) return;
    if (!avisoJefe) {
      setError("Confirmá el aviso a la jefe de área.");
      return;
    }
    if (!exenta && !gestionaReposicion) {
      setError(
        "Confirmá la gestión de reposición al proveedor (reposicion_gestionado)."
      );
      return;
    }
    setGuardando(true);
    setError("");
    try {
      // aviso_jefe no existe en el contrato: el PATCH exitoso pasa a pendiente_jefe.
      // Si está exenta, el back marca la reposición solo; no enviar reposicion_gestionado.
      const body = {};
      if (!exenta) {
        body.reposicion_gestionado = true;
        body.reposicion_obs = "Reposición gestionada / aviso a jefe";
      }
      if (obs.trim()) body.obs = obs.trim();
      await patchPagosRechazo(idRechazo, body);
      onOk?.();
      onClose?.();
    } catch (err) {
      setError(err.message || "Error al registrar Pagos");
    } finally {
      setGuardando(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={guardando ? undefined : onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>Pagos — ficha y aviso a jefe</DialogTitle>
      <DialogContent dividers>
        <Stack spacing={2}>
          {error ? <Alert severity="error">{error}</Alert> : null}
          {exenta ? (
            <Alert severity="warning">
              Reposición exenta: cheque no propio y vencimiento a 30 días
              corridos desde fecha de pago
              {rechazo?.reposicion_exenta_motivo
                ? ` (${rechazo.reposicion_exenta_motivo})`
                : ""}
              . Pagos no gestiona reposición al proveedor.
            </Alert>
          ) : (
            <Alert severity="info">
              Completá la ficha (datos del cheque en plataforma), subí docs y
              gestioná la reposición al proveedor salvo excepción.
            </Alert>
          )}
          {!exenta ? (
            <FormControlLabel
              required
              control={
                <Checkbox
                  checked={gestionaReposicion}
                  onChange={(e) => setGestionaReposicion(e.target.checked)}
                  disabled={guardando}
                />
              }
              label="Gestioné / gestionaré la reposición del eCheq al proveedor"
            />
          ) : null}
          <FormControlLabel
            control={
              <Checkbox
                checked={avisoJefe}
                onChange={(e) => setAvisoJefe(e.target.checked)}
                disabled={guardando}
              />
            }
            label="Di aviso a la jefe de área"
          />
          <TextField
            size="small"
            fullWidth
            multiline
            minRows={2}
            label="Observaciones / datos de ficha (opcional)"
            value={obs}
            onChange={(e) => setObs(e.target.value)}
            disabled={guardando}
          />
          <ExpedienteArchivos
            idRechazo={idRechazo}
            tipoDefault={TIPOS_ARCHIVO_RECHAZO.FICHA_PAGOS}
            compact
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={guardando}>
          Cancelar
        </Button>
        <Button
          variant="contained"
          onClick={guardar}
          disabled={guardando}
          startIcon={guardando ? <CircularProgress size={16} color="inherit" /> : null}
        >
          Pasar a jefe
        </Button>
      </DialogActions>
    </Dialog>
  );
}
